/**
 * Web Audio API Sound Utility
 * Generates synthesized pleasant audio feedback for XP rewards and challenge completions.
 */

export const playSuccessChime = () => {
  try {
    const AudioContextClass = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioContextClass) return;

    const ctx = new AudioContextClass();
    if (ctx.state === 'suspended') {
      ctx.resume();
    }

    // Ascending major chord chime (C5 -> E5 -> G5 -> C6)
    const notes = [
      { freq: 523.25, time: 0.0, duration: 0.18 },
      { freq: 659.25, time: 0.08, duration: 0.20 },
      { freq: 783.99, time: 0.16, duration: 0.24 },
      { freq: 1046.50, time: 0.24, duration: 0.38 },
    ];

    notes.forEach(({ freq, time, duration }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();

      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, ctx.currentTime + time);

      // Attack & decay envelope
      gain.gain.setValueAtTime(0.01, ctx.currentTime + time);
      gain.gain.linearRampToValueAtTime(0.2, ctx.currentTime + time + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + time + duration);

      osc.connect(gain);
      gain.connect(ctx.destination);

      osc.start(ctx.currentTime + time);
      osc.stop(ctx.currentTime + time + duration);
    });
  } catch (err) {
    console.warn('Web Audio playback error:', err);
  }
};
